const createSessionQuery = `mutation createSession( $req:CreateSessionInput ){
  createSession(input: $req) {
    ... on CreateSessionResponse{
      security {
        clientIp
        dataCenter
        session{
        auth
        encryptedSessionId
        id
        }
      }
    }
    ... on ErrorResponse {
      errorCode
      message
      name
    }
    }
  }`

const productApiQuery = `
    query products($req_products: ProductsInput, ) {
      products(input: $req_products) {
        __typename
          ...on ProductsResponse {
            products {
              code
              name
              payIn
              payOut
              fees
              strikeFees
              strikeExchangeRate
              exchangeRate
              destination {
                expectedPayoutAmount
                expectedPayoutAmountLong
                currencyIsoCode
                countryIsoCode
                splitPayOut {
                  expectedPayoutAmount
                  currencyIsoCode
                  exchangeRate
                  countryIsoCode
                }
                actualPayoutAmount
              }
            }
            categories {
              type
              orders {
                payIn
                payOut
              }
            }
          }
          ...on ErrorResponse {
            errorCode
            message
          }
      }
    }`

    const dealsApiQuery = `
      query  deals( $input:DealsInput, ) {
        deals (
            input: $input
        ) {
          __typename
          ... on DealsResponse {
              deals
            }
            ...on ErrorResponse {
              errorCode
              message
            }  
        }
      }`